import { createAsyncThunk } from '@reduxjs/toolkit';
import { RootState } from 'src/redux/store';
import Api from 'src/services/ApiService';

import { CommonAxiosResponse } from 'src/types';
import {
  GetSellOutNvidiaResponse,
  GetSellOutRequest,
  SellOutListResponse,
  SellOutSummaryResponse
} from './types';

export const getSellOutListThunk = createAsyncThunk<
  CommonAxiosResponse<SellOutListResponse>,
  GetSellOutRequest,
  { state: RootState }
>('sell-out/getSellOutListThunk', async (data) => {
  let response: CommonAxiosResponse<SellOutListResponse> = await Api.post(
    '/sales/sell-out/get',
    data
  );

  return response;
});

export const getSellOutSummaryThunk = createAsyncThunk<
  CommonAxiosResponse<SellOutSummaryResponse>,
  GetSellOutRequest,
  { state: RootState }
>('sell-out/getSellOutSummaryThunk', async (data) => {
  let response: CommonAxiosResponse<SellOutSummaryResponse> = await Api.post(
    '/sales/sell-out/get?action=sum',
    data
  );

  return response;
});

export const getSellOutCsvThunk = createAsyncThunk<
  CommonAxiosResponse<any>, //TODO: fix later
  GetSellOutRequest,
  { state: RootState }
>('sell-out/getSellOutCsvThunk', async (data) => {
  const new_params = { ...data, page: null };
  let response: CommonAxiosResponse<any> = await Api.post(
    '/sales/sell-out/get?action=csv',
    new_params
  );

  return response;
});

export const getSellOutNvidiaThunk = createAsyncThunk<
  CommonAxiosResponse<GetSellOutNvidiaResponse>,
  GetSellOutRequest,
  { state: RootState }
>('sell-out/getSellOutNvidiaThunk', async (data) => {
  let response: CommonAxiosResponse<any> = await Api.get(
    '/sales/sell-out/nvidia/get',
    {
      start_date: data.start_date,
      end_date: data.end_date
    }
  );

  return response;
});
